module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Snare Flam-c3b012e79b3d60f3d48b134ace6fd33a.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Snare Flam.mp3
// module id = 53
// module chunks = 0